import { isBancoHomologado } from './bancosHomologados';
import isValidBarcodeDV from './boletoBarcode';

// Motivos de inelegibilidade (CA13/CA04).
export const MOTIVO_SEM_DADOS_BANCARIOS = 'sem-dados-bancarios';
export const MOTIVO_BANCO_NAO_HOMOLOGADO = 'banco-nao-homologado';
export const MOTIVO_CODIGO_BARRAS_INVALIDO = 'codigo-barras-invalido';
export const MOTIVO_ATRASO_EXCEDIDO = 'atraso-excedido';

// Limite de dias em atraso para segunda via (CA09/CA10/CA11). A atividade
// descreve isso como parametrizável por cliente no Configurador, mas essa
// config não existe em nenhum lugar do back (api-charge, backend-virtus, nem
// no app de atendimento virtus-xelt) — confirmado por busca em todo o
// monorepo `duofy/` em 2026-09-15. Por decisão de produto, usamos o default
// fixo global citado na própria atividade (15 dias) até o back expor uma
// config real por cliente — quando isso acontecer, trocar esta constante por
// um valor vindo da API.
export const LIMITE_ATRASO_DIAS = 15;

// Elegibilidade de um título para a segunda via (CA03), a partir do
// sub-objeto `boleto` já recebido na listagem e do número de dias em atraso
// (calculado pelo chamador a partir de `vencto`, ver Dashboard/table.js).
// O atraso é avaliado primeiro: é regra do título (CA10), vale com ou sem
// dados bancários — avaliado depois, um título vencido há mais que o limite
// com boleto incompleto, de banco não homologado ou com DV inválido saía com
// o motivo errado (QA DTGD-1542, plano 000320 título 002).
export default function getBoletoEligibility(boleto, diasAtraso) {
  if (diasAtraso > LIMITE_ATRASO_DIAS) {
    return { eligible: false, reason: MOTIVO_ATRASO_EXCEDIDO };
  }

  const linhaDigitavel = boleto?.linha_digitavel?.trim();
  const codigoBarras = boleto?.codigo_de_barras?.trim();
  const nossoNumero = boleto?.nosso_numero?.trim();

  if (!linhaDigitavel || !codigoBarras || !nossoNumero) {
    return { eligible: false, reason: MOTIVO_SEM_DADOS_BANCARIOS };
  }

  if (!isBancoHomologado(boleto?.codigo_banco)) {
    return { eligible: false, reason: MOTIVO_BANCO_NAO_HOMOLOGADO };
  }

  if (!isValidBarcodeDV(codigoBarras)) {
    return { eligible: false, reason: MOTIVO_CODIGO_BARRAS_INVALIDO };
  }

  return { eligible: true, reason: null };
}
